const englishText: Record<string, string> = {
  "产品": "Product",
  "客户案例": "Case Studies",
  "价格": "Pricing",
  "关于我们": "About",
  "中文 / EN": "中文 / EN",
  "开始试用": "Start Free",
  "登录": "Log in",
  "复制": "Copy",
  "让 TikTok 达人营销": "Scale GMV with",
  "驱动 GMV 增长": "TikTok creator marketing",
  "AI 赋能达人合作全链路，把每次合作沉淀为可复用的增长策略，驱动 GMV 持续增长。": "Let AI empower the entire creator collaboration journey, turning every partnership into a reusable growth strategy that drives sustained GMV growth.",
  "查看产品闭环": "Explore the growth loop",
  "语言切换": "Language switcher",
  "四步增长闭环": "Four-step growth loop",
  "InflowMax 产品演示": "InflowMax product demo",
  "InflowMax 产品闭环总览": "InflowMax product growth loop overview",
  "四个 Agent 工作流，覆盖达人营销增长闭环": "Four Agent workflows, one complete creator growth loop",
  "今日任务推进中": "Today’s work in motion",
  "识别高潜达人 128": "128 high-potential creators identified",
  "生成待审话术 64": "64 outreach drafts ready for review",
  "提醒履约风险 7": "7 fulfillment risks flagged",
  "AI达人发现": "AI Creator Discovery",
  "Agent智能建联": "Agent Outreach",
  "样品履约协同": "Sample Fulfillment",
  "样品履约": "Sample fulfillment",
  "GMV增长复盘": "GMV Insights",
  "今日预计GMV": "Projected GMV today",
  "高匹配达人": "High-match creators",
  "样品履约率": "Sample fulfillment rate",
  "进入推荐池": "Added to the recommendation pool",
  "01 达人发现": "01 Discovery",
  "02 Agent智能建联": "02 Outreach",
  "03 样品履约协同": "03 Fulfillment",
  "04 GMV增长复盘": "04 GMV Insights",
  "从海量达人中找到": "Find the creators",
  "真正值得合作的人": "worth partnering with",
  "粉丝画像": "Audience profile",
  "内容调性": "Content style",
  "历史表现": "Past performance",
  "GMV潜力": "GMV potential",
  "AI 达人匹配与推荐理由": "AI creator matching with clear recommendations",
  "AI达人推荐列表": "AI Creator Recommendations",
  "已分析 1,234,567+ 达人": "1,234,567+ creators analyzed",
  "达人": "Creator",
  "粉丝量": "Followers",
  "内容类目": "Content category",
  "匹配分": "Match score",
  "下一步": "Next step",
  "美妆个护": "Beauty & Personal Care",
  "美妆教程": "Beauty tutorials",
  "护肤": "Skincare",
  "时尚穿搭": "Fashion & Style",
  "加入建联队列": "Add to outreach queue",
  "AI 推荐理由": "Why AI recommends this creator",
  "受众与品牌目标人群重合度高": "Strong audience overlap with your target customer",
  "近30天内容互动稳定": "Consistent content engagement over the last 30 days",
  "同类商品转化潜力较高": "High conversion potential for similar products",
  "推荐会持续学习品牌偏好。": "Recommendations continue learning your brand preferences.",
  "AI Agent 自动生成话术，持续跟进不遗漏": "AI Agents generate outreach and keep every follow-up on track",
  "AI 个性化生成": "AI-personalized messaging",
  "自动排队跟进": "Automated follow-up queue",
  "人工审批控制": "Human approval controls",
  "建联任务队列": "Outreach task queue",
  "128 个任务 · 16 个回复": "128 tasks · 16 replies",
  "128.6K 粉丝": "128.6K followers",
  "87.3K 粉丝": "87.3K followers",
  "213.4K 粉丝": "213.4K followers",
  "142.7K 粉丝": "142.7K followers",
  "美国": "United States",
  "英国": "United Kingdom",
  "加拿大": "Canada",
  "待发送": "Ready to send",
  "AI 已生成建联话术": "AI outreach copy generated",
  "已回复": "Replied",
  "达人已回复": "Creator replied",
  "跟进中": "Following up",
  "已发送 24h 跟进": "24h follow-up sent",
  "需确认": "Needs confirmation",
  "AI 识别需人工确认": "AI flagged for human confirmation",
  "发送建联消息": "Send outreach message",
  "继续沟通": "Continue conversation",
  "发送样品邀约": "Send sample invitation",
  "人工确认后发送": "Send after human approval",
  "初次建联": "Initial outreach",
  "24h 跟进": "24h follow-up",
  "样品邀约": "Sample invitation",
  "为 Luna_Glow 生成的建联话术": "Outreach copy generated for Luna_Glow",
  "中文": "Chinese",
  "运行中": "Running",
  "Hi Luna，我们很喜欢你的护肤内容。想邀请你体验新品，并沟通合作形式。": "Hi Luna, we love your skincare content. We’d love to invite you to try our new product and explore a collaboration.",
  "AI 建议跟进节奏": "AI-recommended follow-up cadence",
  "已完成": "Complete",
  "从内容表现回到 GMV 结果，": "Connect content performance to GMV results,",
  "找到下一轮增长机会": "then find the next growth opportunity",
  "样品申请、审核、发货、签收，": "From sample requests and approvals to shipping and delivery,",
  "每一步都有 Agent 跟进": "an Agent keeps every step moving",
  "Agent履约提醒": "Agent fulfillment alerts",
  "2 个样品超过 48h 未发货": "2 samples have not shipped after 48h",
  "1 位达人资料待补充": "1 creator profile needs more information",
  "3 个订单建议今日跟进": "3 orders should be followed up today",
  "样品申请": "Sample request",
  "资质审核": "Qualification review",
  "发货中": "Shipping",
  "已签收 / 待内容": "Delivered / content pending",
  "HydraGlow 精华液": "HydraGlow Serum",
  "待审核": "Pending review",
  "资质评分 92 分": "Qualification score: 92",
  "审核中": "In review",
  "资料待补充": "More information needed",
  "待补充": "More information needed",
  "4PX 运输中": "4PX in transit",
  "Yanwen 运输中": "Yanwen in transit",
  "运输中": "In transit",
  "Barrier Cream": "Barrier Cream",
  "待内容": "Content pending",
  "团队负责人": "Team owners",
  "市场负责人 Jing Li": "Marketing lead: Jing Li",
  "样品负责人 Kevin Zhou": "Sample lead: Kevin Zhou",
  "运营负责人 Mia Wang": "Operations lead: Mia Wang",
  "本周准时履约率": "On-time fulfillment this week",
  "较上周 +6.2pp": "+6.2pp from last week",
  "GMV 30天": "30-day GMV",
  "内容发布率": "Content publish rate",
  "转化率": "Conversion rate",
  "复投建议达人": "Creators recommended for reinvestment",
  "占比 20%": "20% of total",
  "GMV 趋势": "GMV trend",
  "GMV 趋势图": "GMV trend chart",
  "GMV +24.7% · 内容发布率 +12.4pp": "GMV +24.7% · Content publish rate +12.4pp",
  "近30天": "Last 30 days",
  "达人表现排行榜": "Creator performance ranking",
  "GMV贡献": "GMV contribution",
  "优先复投": "Prioritize reinvestment",
  "复投": "Reinvest",
  "优化内容": "Optimize content",
  "观察": "Monitor",
  "AI增长建议": "AI growth recommendations",
  "优先复投 Top 20% 高转化达人": "Prioritize the top 20% of high-converting creators",
  "Top 20% 达人贡献了主要 GMV，建议优先追加样品支持。": "The top 20% of creators drive most GMV. Prioritize them for additional sample support.",
  "调整低转化内容脚本方向": "Refine scripts for lower-converting content",
  "对已出单达人开启二次建联": "Re-engage creators who have already converted",
  "生成下轮建联计划": "Generate the next outreach plan",
  "让 AI Agent 持续驱动 TikTok 达人营销增长": "Let AI Agents keep driving TikTok creator growth",
  "按达人营销增长阶段选择套餐": "Choose a plan for your creator growth stage",
  "从刚开始验证达人建联，到需要团队协同和 AI Agent 自动跟进， InflowMax.ai 用清晰的套餐承接不同阶段的增长需求。": "From validating your first creator outreach to coordinating teams and automated AI Agent follow-up, InflowMax.ai has a clear plan for each stage of growth.",
  "InflowMax.ai 用清晰的套餐承接不同阶段的增长需求。": "InflowMax.ai offers clear plans for every stage of creator growth.",
  "起步验证": "Validate the basics",
  "适合刚开始做 TikTok 达人建联的品牌。": "For brands getting started with TikTok creator outreach.",
  "待定": "Custom",
  "推荐": "Recommended",
  "试用期报价待确认": "Trial pricing available on request",
  "联系试用": "Contact us",
  "1 个品牌工作区": "1 brand workspace",
  "每月 2,000 位达人检索额度": "2,000 creator searches per month",
  "基础建联任务队列": "Core outreach task queue",
  "样品履约状态追踪": "Sample fulfillment tracking",
  "增长闭环": "Growth loop",
  "适合已经有稳定达人合作节奏，需要 AI Agent 提效的团队。": "For teams with an established creator cadence that want AI Agent efficiency.",
  "3 个品牌工作区": "3 brand workspaces",
  "每月 10,000 位达人检索额度": "10,000 creator searches per month",
  "AI Outreach Agent 话术生成": "AI Outreach Agent copy generation",
  "24h / 48h 自动跟进提醒": "Automated 24h / 48h follow-up reminders",
  "样品履约异常提醒": "Sample fulfillment exception alerts",
  "GMV 复盘和复投建议": "GMV insights and reinvestment recommendations",
  "规模化团队": "Scale your team",
  "适合多品牌、多市场、多运营角色协同的增长团队。": "For growth teams coordinating across brands, markets, and operating roles.",
  "按团队规模和达人额度确认": "Tailored to team size and creator volume",
  "联系销售": "Contact sales",
  "多品牌 / 多市场工作区": "Multi-brand / multi-market workspaces",
  "自定义达人检索和建联额度": "Custom creator search and outreach limits",
  "团队角色和审批流": "Team roles and approval flows",
  "履约负责人和风险看板": "Fulfillment ownership and risk dashboards",
  "数据导出与 BI 对接支持": "Data export and BI integration support",
  "机构合作": "Agency partnership",
  "适合服务多个出海品牌的代理商、服务商和运营团队。": "For agencies and service teams supporting multiple global brands.",
  "按客户数、席位数和服务深度确认": "Tailored to client count, seats, and service depth",
  "咨询合作": "Discuss a partnership",
  "多客户工作区": "Multi-client workspaces",
  "客户级数据隔离": "Client-level data isolation",
  "批量建联和履约管理": "Bulk outreach and fulfillment management",
  "跨客户 GMV 复盘报表": "Cross-client GMV insight reports",
  "专属实施和培训支持": "Dedicated implementation and training",
  "每个套餐都围绕增长闭环设计": "Every plan is built around the growth loop",
  "达人发现": "Creator discovery",
  "达人检索、匹配评分、推荐理由": "Creator search, match scoring, and recommendation rationale",
  "智能建联": "Smart outreach",
  "话术生成、任务队列、人工审批": "Message generation, task queues, and human approval",
  "履约协同": "Fulfillment coordination",
  "样品申请、审核、发货、签收提醒": "Sample requests, approvals, shipping, and delivery reminders",
  "GMV复盘": "GMV insights",
  "内容表现、转化贡献、复投建议": "Content performance, conversion contribution, and reinvestment guidance",
  "常见问题": "Frequently asked questions",
  "现在的价格是正式价格吗？": "Are these final prices?",
  "当前页面用于官网展示和试用沟通。正式商业化价格可以根据 MVP 试用反馈再调整。": "This page is for product discovery and trial conversations. Commercial pricing may evolve based on MVP trial feedback.",
  "可以先不绑定长期套餐吗？": "Can we start without a long-term commitment?",
  "可以。早期客户可以先从试用方案开始，确认达人建联和履约闭环价值后再升级。": "Yes. Early customers can begin with a trial and upgrade after validating the value of outreach and fulfillment workflows.",
  "AI Agent 会自动发送消息吗？": "Will the AI Agent send messages automatically?",
  "默认保留人工确认。Agent 负责生成建议、提醒节奏和识别风险，关键触达由团队确认后发送。": "Human approval remains the default. Agents generate recommendations, maintain cadence, and flag risks; your team approves key outreach before it is sent.",
  "是否支持团队协同？": "Does it support team collaboration?",
  "Growth 以上方案面向多角色协作，支持达人建联、样品履约和 GMV 复盘中的负责人分工。": "Growth plans and above support multi-role collaboration across outreach, sample fulfillment, and GMV insights.",
  "不确定选哪个套餐？先开始试用": "Not sure which plan fits? Start with a trial",
  "客户案例切换": "Switch customer story",
  "客户品牌": "Customer brands",
  "女装品牌": "Women's apparel brand",
  "工具品牌": "Tool brand",
  "OQQ 官方 Logo": "OQQ official logo",
  "VEVOR 官方 Logo 与品牌标语": "VEVOR official logo and brand line",
  "大规模达人合作": "Scale creator partnerships",
  "更有序地推进": "with a clearer operating system",
  "Agent 承接规模化执行与持续跟进，把一人多样、一品多人的合作管好，让团队降本增效。": "Agents handle high-volume execution and follow-up, organizing multiple samples per creator and multiple creators per product so teams can do more with less.",
  "查看合作成果": "See the results",
  "Agent 共创路径": "How the Agents work",
  "案例重点": "Case highlights",
  "达人管理": "Creator management",
  "一人多样": "Multiple samples per creator",
  "一品多人": "Multiple creators per product",
  "OQQ 品牌与产品展示": "OQQ brand and product showcase",
  "OQQ 官网模特展示浅色短袖拉链连体服": "OQQ model wearing a light short-sleeve zip romper",
  "OQQ 服饰系列": "OQQ apparel collection",
  "合作成果": "The impact",
  "规模增长与执行效率同步改善": "Scale and execution efficiency improved together",
  "团队规模缩减": "Smaller operating team",
  "Agent 管理大规模合作，减少人工投入": "Agents manage high-volume partnerships with less manual work",
  "月度达人视频产出增长": "Monthly creator video output",
  "Agent 持续推进样品到视频交付": "Agents move every sample through to video delivery",
  "单达人月均视频产出": "Monthly videos per creator",
  "条 / 月": "videos / month",
  "一位达人，多样品持续出片": "Each creator produces across multiple samples",
  "合作规模在扩大，": "Creator partnerships keep scaling,",
  "管理成本不必同步增加。": "without scaling management cost.",
  "一位达人 · 多款样品": "One creator · multiple samples",
  "一款商品 · 更多达人": "One product · more creators",
  "01 / 管理": "01 / Manage",
  "按人按品组织合作": "Organize by creator and product",
  "一人多样 · 一品多人": "Multiple samples per creator · multiple creators per product",
  "02 / 沟通": "02 / Communicate",
  "Agent 承接重复沟通": "Agents handle repetitive outreach",
  "常见问题处理，复杂情况转人工": "Handle common questions and escalate complex cases",
  "03 / 履约": "03 / Fulfill",
  "持续跟进寄样出片": "Keep samples and content moving",
  "Agent 关联达人、样品与交付视频": "Agents connect creators, samples, and delivered videos",
  "04 / 优化": "04 / Optimize",
  "复盘并优化合作管理": "Review and improve partnership operations",
  "Agent 沉淀履约和产出，复用高产合作": "Agents learn from delivery and output to repeat high-performing partnerships",
  "达人管理知识库": "Creator management knowledge base",
  "合作记录 · 样品履约 · 视频产出": "Partnership history · sample fulfillment · video output",
  "TikTok Shop Top1 女装品牌": "TikTok Shop’s #1 women’s apparel brand",
  "InflowMax 帮我们把大规模达人管得更好，让合作铺得开，内容跟得上。": "InflowMax helps us manage creators at scale, expand partnerships, and keep content delivery on pace.",
  "“InflowMax 帮我们把大规模达人管得更好，让合作铺得开，内容跟得上。”": "“InflowMax helps us manage creators at scale, expand partnerships, and keep content delivery on pace.”",
  "— OQQ 创始人": "— OQQ Founder",
  "开启达人增长": "Start growing with creators",
  "让每个商品": "Give every product",
  "找到对的达人": "the right creators",
  "每款产品都有明确的使用场景。AI 与 Agent 从优质合作中提炼画像，按 SKU 匹配达人，再拓展池外合适人选。": "Every product has a distinct use case. AI and Agents learn from strong partnerships, build a profile for each SKU, and find the right creators inside and beyond the existing pool.",
  "场景分析": "Scenario analysis",
  "多 SKU 匹配": "Multi-SKU matching",
  "精准达人拓展": "Targeted creator expansion",
  "VEVOR 品牌与产品展示": "VEVOR brand and product showcase",
  "VEVOR 家居产品使用场景": "VEVOR home product in use",
  "人物手持电钻制作木架的产品使用场景，AI 生成示意图": "AI-generated product scenario showing a person building a wooden shelf with a drill",
  "商品匹配、履约与优质素材同步提升": "Better matching, fulfillment, and high-quality creative output",
  "商品与达人匹配度提升": "Product-creator fit",
  "Agent 按产品场景匹配更合适的达人": "Agents match creators to each product’s real use case",
  "达人有效素材履约率提升": "Usable creative fulfillment",
  "Agent 推进有效素材按约交付": "Agents keep usable creative on schedule",
  "达人优质素材产出量提升": "High-quality creator assets",
  "更多符合产品场景的优质素材": "More quality assets that fit the product scenario",
  "先看产品使用场景，": "Start with the product use case,",
  "再找真正适合的达人。": "then find creators who truly fit.",
  "明确的产品使用场景": "Clear product use cases",
  "已合作优质达人与素材": "Proven creators and creative assets",
  "目标画像": "Target profile",
  "内容能力": "Content capability",
  "使用场景": "Use case",
  "受众特征": "Audience fit",
  "履约表现": "Fulfillment performance",
  "01 / 解析": "01 / Analyze",
  "解析优质达人与素材": "Analyze proven creators and assets",
  "AI 从产品内容识别场景与达人特征": "AI identifies use cases and creator traits from product content",
  "02 / 匹配": "02 / Match",
  "建立 SKU 目标画像": "Build a target profile for each SKU",
  "Agent 围绕使用场景匹配达人能力": "Agents match creator capabilities to the use case",
  "03 / 拓展": "03 / Expand",
  "拓展池外精准达人": "Expand beyond the existing creator pool",
  "Agent 从目标画像泛化寻找合适人选": "Agents use the target profile to find new qualified creators",
  "04 / 学习": "04 / Learn",
  "复盘并校准画像": "Review and refine the profile",
  "内容质量 · 履约 · 素材复用": "Content quality · fulfillment · asset reuse",
  "商品 × 达人 × 素材知识库": "Product × creator × asset knowledge base",
  "沉淀场景与匹配依据，支持 Agent 持续校准": "Capture use cases and match signals so Agents keep improving",
  "VEVOR 品牌门店": "VEVOR brand store",
  "TikTok Shop Top1 工具品牌": "TikTok Shop’s #1 tools brand",
  "现在的达人匹配精准很多，产出的内容也更有价值。这是我们和 InflowMax 合作最看重的一点。": "Creator matching is much more precise now, and the content is more valuable. That is what matters most in our work with InflowMax.",
  "“现在的达人匹配精准很多，产出的内容也更有价值。这是我们和 InflowMax 合作最看重的一点。”": "“Creator matching is much more precise now, and the content is more valuable. That is what matters most in our work with InflowMax.”",
  "— VEVOR 品牌总监": "— VEVOR Brand Director",
  "客户案例内容规划": "Customer story framework",
  "正式案例内容待补充，后续将展示 TikTok Shop 出海品牌的达人营销增长实践。": "Customer stories are coming soon. This page will feature creator growth programs from global TikTok Shop brands.",
  "正式案例内容待补充。这里先保留独立页面入口，后续用于展示 TikTok Shop 出海品牌在达人发现、智能建联、样品履约和 GMV 复盘中的真实增长实践。": "Customer stories are coming soon. This standalone page will feature real creator growth programs from global TikTok Shop brands across discovery, outreach, fulfillment, and GMV insights.",
  "品牌背景": "Brand context",
  "补充客户所在品类、市场阶段、达人营销目标和原有运营痛点。": "Add the client’s category, market stage, creator marketing objectives, and operational challenges.",
  "增长动作": "Growth actions",
  "补充 InflowMax.ai 在达人筛选、建联、履约和复盘中的具体使用方式。": "Add how InflowMax.ai was used across creator selection, outreach, fulfillment, and insights.",
  "结果指标": "Outcome metrics",
  "补充合作达人数、内容发布率、GMV 贡献、复投效率等经确认的数据。": "Add verified data such as creators engaged, publishing rate, GMV contribution, and reinvestment efficiency.",
  "想先验证自己的达人增长闭环？": "Ready to validate your own creator growth loop?",
  "达人营销AI操盘手。面向 TikTok 出海品牌，打通达人发现、智能建联、样品履约和 GMV 复盘。": "The AI operator for TikTok creator marketing. Connect discovery, smart outreach, fulfillment, and GMV insights.",
  "产品概览": "Product overview",
  "产品流程": "Product flow",
  "主导航": "Primary navigation",
  "页脚导航": "Footer navigation",
  "价格套餐": "Pricing plans"
};

const englishMetadata: Record<string, { title: string; description: string }> = {
  "/": {
    title: "InflowMax.ai | AI Operator for TikTok Creator Marketing",
    description: "InflowMax.ai is an AI operator for TikTok creator marketing, connecting creator discovery, AI outreach, sample fulfillment, and GMV insights."
  },
  "/pricing": {
    title: "Pricing | AI Creator Marketing Operator | InflowMax.ai",
    description: "Explore InflowMax.ai plans for TikTok creator discovery, AI outreach, sample fulfillment, and GMV insights."
  },
  "/case-studies": {
    title: "Case Studies | AI Creator Marketing Operator | InflowMax.ai",
    description: "See how OQQ uses InflowMax.ai to scale TikTok creator partnerships, fulfillment, and marketing efficiency."
  }
};

type Locale = "zh" | "en";

const localeStorageKey = "inflowmax.locale";
const chineseTimeZones = new Set([
  "Asia/Chongqing",
  "Asia/Harbin",
  "Asia/Hong_Kong",
  "Asia/Macau",
  "Asia/Shanghai",
  "Asia/Taipei",
  "Asia/Urumqi"
]);

const getStoredLocale = (): Locale | null => {
  try {
    const locale = window.localStorage.getItem(localeStorageKey);
    return locale === "zh" || locale === "en" ? locale : null;
  } catch {
    return null;
  }
};

const getRequestedLocale = (): Locale | null => {
  const locale = new URLSearchParams(window.location.search).get("lang");
  return locale === "zh" || locale === "en" ? locale : null;
};

const detectLocale = (): Locale => {
  const browserLanguages = navigator.languages?.length ? navigator.languages : [navigator.language];

  if (browserLanguages.some((language) => language.toLowerCase().startsWith("zh"))) return "zh";
  if (browserLanguages.some((language) => language.toLowerCase().startsWith("en"))) return "en";

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return chineseTimeZones.has(timeZone) ? "zh" : "en";
};

const resolveLocale = (): Locale => getStoredLocale() ?? getRequestedLocale() ?? detectLocale();

const persistLocale = (locale: Locale) => {
  try {
    window.localStorage.setItem(localeStorageKey, locale);
  } catch {
    // Locale detection remains available when storage is disabled.
  }
};

const preserveWhitespace = (source: string, replacement: string) => {
  const leading = source.match(/^\s*/)?.[0] ?? "";
  const trailing = source.match(/\s*$/)?.[0] ?? "";
  return `${leading}${replacement}${trailing}`;
};

const translateTextNodes = (translations = englishText) => {
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const textNodes: Text[] = [];
  let node: Node | null;

  while ((node = walker.nextNode())) {
    if (node.parentElement?.closest("script, style")) continue;
    textNodes.push(node as Text);
  }

  textNodes.forEach((textNode) => {
    const source = textNode.nodeValue ?? "";
    const key = source.trim().replace(/\s+/g, " ");
    const translation = translations[key];
    if (translation) {
      textNode.nodeValue = preserveWhitespace(source, translation);
    }
  });
};

const translateAttributes = (translations = englishText) => {
  const attributes = ["aria-label", "title", "alt", "placeholder"] as const;

  document.querySelectorAll<HTMLElement>("[aria-label], [title], [alt], [placeholder]").forEach((element) => {
    attributes.forEach((attribute) => {
      const source = element.getAttribute(attribute);
      if (!source) return;

      const key = source.trim().replace(/\s+/g, " ");
      const translation = translations[key];
      if (translation) element.setAttribute(attribute, translation);
    });
  });
};

export const translateAdditionalContent = (translations: Record<string, string>) => {
  if (document.documentElement.lang !== "en") return;
  translateTextNodes(translations);
  translateAttributes(translations);
};

const translateMetadata = () => {
  const metadata = englishMetadata[window.location.pathname];
  if (!metadata) return;

  document.title = metadata.title;
  document.querySelector<HTMLMetaElement>('meta[name="description"]')?.setAttribute("content", metadata.description);
  document.querySelector<HTMLMetaElement>('meta[property="og:title"]')?.setAttribute("content", metadata.title);
  document.querySelector<HTMLMetaElement>('meta[property="og:description"]')?.setAttribute("content", metadata.description);
  document.querySelector<HTMLMetaElement>('meta[name="twitter:title"]')?.setAttribute("content", metadata.title);
  document.querySelector<HTMLMetaElement>('meta[name="twitter:description"]')?.setAttribute("content", metadata.description);
};

const setLocaleLink = (link: HTMLAnchorElement, locale: string, isEnglish: boolean) => {
  const target = new URL(window.location.href);
  const isActive = (locale === "en") === isEnglish;

  if (locale === "zh") {
    target.searchParams.delete("lang");
  } else {
    target.searchParams.set("lang", "en");
  }

  link.setAttribute("aria-current", isActive ? "page" : "false");
  link.setAttribute("aria-label", locale === "zh" ? "切换至中文" : "Switch to English");
  link.href = `${target.pathname}${target.search}${target.hash}`;
};

export const initializeLocale = () => {
  const locale = resolveLocale();
  const isEnglish = locale === "en";
  const languageSwitches = Array.from(document.querySelectorAll<HTMLAnchorElement>("[data-locale-switch]"));

  languageSwitches.forEach((link) => setLocaleLink(link, link.dataset.localeSwitch ?? "zh", isEnglish));
  languageSwitches.forEach((link) => {
    link.addEventListener("click", () => {
      const selectedLocale = link.dataset.localeSwitch;
      if (selectedLocale === "zh" || selectedLocale === "en") persistLocale(selectedLocale);
    });
  });

  if (!isEnglish) return;

  document.documentElement.lang = "en";
  translateTextNodes();
  translateAttributes();
  translateMetadata();

  document.querySelectorAll<HTMLAnchorElement>('a[href^="/"]').forEach((link) => {
    if (link.hasAttribute("data-locale-switch") || link.getAttribute("href") === "/privacy-policy") return;
    const target = new URL(link.href, window.location.origin);
    target.searchParams.set("lang", "en");
    link.href = `${target.pathname}${target.search}${target.hash}`;
  });
};
